import React, { useState, useEffect } from 'react'
import { Form, Button, Checkbox, message, Input } from 'antd';

import FontSelector from '../common/FontSelector';
import FontSizeSelector from '../common/FontSizeSelector';
import {callApi} from '../../helpers/Api';

const FontEditor = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [initialValues, setInitialValues] = useState({});

    const [form] = Form.useForm();

    const inputStyle = {marginBottom: '0'}

    useEffect(()=>{
        setInitialValues({
            font: props.userStyle?.font ? props.userStyle.font : 'Georgia, serif',
            font_size: props.userStyle?.font_size ? props.userStyle.font_size : 14,
            font_color: props.userStyle?.font_color ? props.userStyle.font_color : '#000000',
            background_color: props.userStyle?.background_color ? props.userStyle.background_color : '#ffffff',
            is_default: props.userStyle?.is_default ? props.userStyle.is_default : false,
        })
    }, [props])

    useEffect(() => {
        form.resetFields()
    }, [initialValues])

    const handleSubmit = (e) => {
        e.preventDefault()
        form.validateFields()
        .then(values => {
            setIsSubmitting(true);
            if(props.customHandleSubmit) {
                props.customHandleSubmit(values);
            } else {
                callApi('/api/own/read_config', {
                    method: 'POST',
                    body: JSON.stringify(values),
                })
                .then(res => {
                    if (res) {
                        message.success('Read settings saved!');
                        props.pullUserStyle();
                    } else {
                        message.error('We have encountered an error. Please try again later.');
                    }
                })
                .catch(err => console.log(err));

                props.close();
            }
            setIsSubmitting(false);
        })
        .catch(errorInfo => {
            console.log(errorInfo)
        });
    }

    return (
        <Form form={form} layout='vertical' initialValues={initialValues}>
            
            <FontSelector />
            <FontSizeSelector />
            <Form.Item
                name="font_color"
                label="Font Color"
                rules={[
                    {
                        required: true,
                        message: 'Font Color is required',
                    },
                ]}
            >
                <Input type="color" name="font_color" style={{width: '50px', padding: '2px'}}/>
            </Form.Item>
            <Form.Item
                name="background_color"
                label="Background Color"
                rules={[
                    {
                        required: true,
                        message: 'Background Color is required',
                    }
                ]}
            >
                <Input type="color" name="background_color" style={{width: '50px', padding: '2px'}}/>
            </Form.Item>
            {props.hideDefault ? null : (
            <Form.Item
                name="is_default"
                valuePropName='checked'
            >
                <Checkbox><p className="text-darkable" style={{display: 'inline'}}>Default stories to your font?</p></Checkbox>
            </Form.Item>
            )}
            <Form.Item style={inputStyle} >
                <Button block type="primary" htmlType="submit" onClick={handleSubmit} disabled={(isSubmitting)}>
                    {props.buttonText ? props.buttonText : 'Submit'}
                </Button>
            </Form.Item>
        </Form>
    );
}

export default FontEditor;